module.exports = __webpack_public_path__ + "static/media/avoid-example.171b1e45.png";